/* angular:styles/component:css;9fcece0610a70427673996c78515642654d47d1a7e0871293ff8d5690017ad46;/app/src/app/shared/animations/save-button2.component.ts */
.button {
  width: 186px;
  height: 62px;
  border-radius: 30px;
  box-shadow: 1px 2px 8px 0 rgba(0, 0, 0, 0.5);
  background-color: #61566e;
  font-family: "Poppins-Regular";
  font-size: 14px;
  color: #f2eee7;
  transition-duration: 0.4s;
  position: fixed;
  bottom: 16px;
  left: calc(50% - 93px + 144px);
}
.button:hover {
  background-color: #3c3446;
}
@media (max-width: 1390px) and (min-width: 600px) {
  .button {
    left: calc(50% - 93px + 40px);
  }
}
@media (max-width: 599px) {
  .button {
    left: calc(50% - 93px);
    bottom: 69px;
  }
}
/*# sourceMappingURL=save-button2.component.css.map */
